/**
 * Absolute http(s) URL guard for partner-entered links and image URLs that
 * land in `href` / `src` on the storefront (React 18 still renders
 * `javascript:` hrefs). Returns the trimmed input when it is an absolute
 * http:// or https:// URL with a host, otherwise null.
 */
export function safeHttpUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!/^https?:\/\//i.test(trimmed)) return null;
  try {
    const url = new URL(trimmed);
    if ((url.protocol !== "http:" && url.protocol !== "https:") || !url.hostname) return null;
    return trimmed;
  } catch {
    return null;
  }
}
